import { useState } from "react";
import ShowMyOrder from "./showMyOrder";
import { DeliveryDining, ExpandMore, LocalMallOutlined } from "@mui/icons-material";
import MyDateTime from "../../../DTechComp/MyDateTime";
import OrderFunctions from "../../../OrderSettings/OrderFunctions";
import "../MyProfile.css";


const MyFutureOrderDisp = (props) => {

    const [theOrder] = useState(props.theOrder);
    const [shown, setShown] = useState(false);

    const isDeliver = theOrder.ord.OrderType !== "Take";

    return (
        <div className={"ordAccordionItem futureOrdAccordionItem"}>

            <div className={"ordAccordionHeader"} onClick={() => setShown(!shown)}>
                <div className={`ordAccordionIcon futureOrdAccordionIcon${isDeliver ? " ordAccordionIcon--deliver" : ""}`}>
                    {isDeliver
                        ? <DeliveryDining sx={{ color: '#41bd31', fontSize: 18 }} />
                        : <LocalMallOutlined sx={{ color: '#534AB7', fontSize: 18 }} />
                    }
                </div>
                <div className={"fullRow"}>
                    <span className={"mediumst futureOrdScheduledFor"}>
                        הזמנה עתידית ל {MyDateTime.getShortTime(theOrder.ord.scheduledFor)} {MyDateTime.getDate(theOrder.ord.scheduledFor)}
                    </span>
                    <br />
                    <p className={"MbigFont"}>{theOrder.buiss.buissName}</p>
                </div>
                <div className={"fullRow"}>

                    {isDeliver ? "משלוח" : "איסוף"}
                    {", "}
                    {theOrder.ord.orderStatus}
                </div>
                <ExpandMore className={`ordAccordionChevron${shown ? " ordAccordionChevron--open" : ""}`} />
            </div>

            <div className={`ordAccordionBody${shown ? " ordAccordionBody--open" : ""}`}>
                <div className={"col-12"}>
                    <div className={"row"}>

                        <div className={"col-12 pointing"}>
                            <div className={"MbigFont bold SecondFont onRight"}>{theOrder.buiss.buissName}</div>
                        </div>

                        <div className={"col-12"}>
                            <div className={"openOrdBx orderLINE"}>
                                <div className={"small"}>מספר הזמנה: {theOrder.ord.orderNUM}</div>
                            </div>
                        </div>

                        <div className={"col-12"}>
                            <div className={"openOrdBx fulllRow overflowHid"}>
                                <div className={"small"}>{OrderFunctions.payingTYpe(theOrder.ord.payt)}: {OrderFunctions.getOrderToPay(theOrder.ord)} ₪</div>
                            </div>
                        </div>

                        <div className={"countTxtOrder"}>
                            <div className={"big"}>סטטוס: {theOrder.ord.orderStatus}</div>
                        </div>

                        <div className={"col-12 clearFloat"}>
                            <div className={"openOrdBx fulllRow overflowHid"}>
                                <div className={"big futureOrdScheduledFor"}>
                                    הזמנה עתידית ל {MyDateTime.getShortTime(theOrder.ord.scheduledFor)} {MyDateTime.getDate(theOrder.ord.scheduledFor)}
                                </div>
                            </div>
                        </div>

                        <ShowMyOrder theOrder={theOrder.ord} />

                    </div>
                </div>
            </div>

        </div>
    );
};

export default MyFutureOrderDisp;
